export const INVOICE_PREFIX = "#UCF0";

export const randomNumberInRange = () => {
  return Math.floor(Math.random() * (1000 - 1 + 1)) + 1;
};
